import { observer } from "mobx-react-lite";
import React, { Fragment, useContext } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Pagination, Segment, Table } from "semantic-ui-react";
import BannerListItem from "./BannerListItem";

const BannerList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    bannersByCode,
    loadBanners,
    setPage,
    page,
    totalPages,
  } = rootStore.bannerStore;

  const onPageChange = (e: any, pageInfo: any) => {
    setPage(pageInfo.activePage);
    loadBanners();
  };

  return (
    <Fragment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={4}>Local do banner</Table.HeaderCell>
            <Table.HeaderCell width={6}>Imagem</Table.HeaderCell>
            <Table.HeaderCell width={6}>Url de Redirecionamento</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {bannersByCode.map((banner) => (
            <BannerListItem key={banner.id} banner={banner} />
          ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="3">
              <Segment basic clearing floated="right">
                <Pagination
                  defaultActivePage={page}
                  onPageChange={(e, pageInfo) => onPageChange(e, pageInfo)}
                  totalPages={totalPages}
                />
              </Segment>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Fragment>
  );
};

export default observer(BannerList);
